// Auto generated file, do not manually modify!
// com.hotpads.admanagement.api.web.external.handler.AdManagementUserContractsApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AdManagementSubscriptionContractsDto } from '../..';

interface GetDocumentEditorUrlParams {
  documentId: string;
}

export const AdManagementUserContractsApiHandler_getDocumentEditorUrl_Path =
  '/api/web/v1/userSubscriptionPaths/getDocumentEditorUrl';

/**
 * Return Document editor url
 */
export const AdManagementUserContractsApiHandler_getDocumentEditorUrl = (
  getParams: GetDocumentEditorUrlParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetDocumentEditorUrlParams, never, string>(
    {
      getParams: getParams,
      endpoint: AdManagementUserContractsApiHandler_getDocumentEditorUrl_Path,
      method: 'GET',
      contextPath: '/ad-management',
    },
    client,
  );
};

export const AdManagementUserContractsApiHandler_getSubscriptionContractDetails_Path =
  '/api/web/v1/userSubscriptionPaths/getSubscriptionContractDetails';

/**
 * Return Logged in User's Subscription Contracts
 */
export const AdManagementUserContractsApiHandler_getSubscriptionContractDetails = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<AdManagementSubscriptionContractsDto>>(
    {
      endpoint: AdManagementUserContractsApiHandler_getSubscriptionContractDetails_Path,
      method: 'GET',
      contextPath: '/ad-management',
    },
    client,
  );
};
